// hosting.api.js
import axios from 'axios';

/**
 * Create a new hosting request
 * @param {Object} requestData
 * @param {String} requestData.hostId
 * @param {String} requestData.checkIn
 * @param {String} requestData.checkOut
 * @param {String} [requestData.message]
 */
export async function createHostingRequest(requestData) {
  return await axios.post('/api/hosting-requests', requestData, {
    withCredentials: true, // Important if using cookies/session
  });
}

/**
 * Get hosting requests for logged-in GUEST (sent by current user)
 */
export async function fetchGuestRequests(guestId) {
  const { data } = await axios.get(`/api/hosting-requests/guest/${guestId}`);
  return data;
}

/**
 * Get hosting requests received by HOST (to accept/reject)
 */
export async function fetchHostRequests(hostId) {
  const { data } = await axios.get(`/api/hosting-requests/host/${hostId}`);
  return data;
}

/**
 * Update request status (accept or reject)
 * @param {String} requestId
 * @param {String} status - 'accepted' or 'rejected'
 */
export async function updateRequestStatus(requestId, status) {
  return await axios.put(`/api/hosting-requests/${requestId}/status`, {
    status,
  });
}
